module.exports = __webpack_public_path__ + "assets/images/project/india.jpg?v=55530731";